<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title pt-2 px-2">
        <div class="row">
          <div class="col-xl-3">
            <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control flex-basis-50" autocomplete="off" [(ngModel)]="filter_string" (ngModelChange)="search()" />
          </div>
          <div class="col-xl-3" [ngClass.sm]="'my-1'" [ngClass.md]="'my-1'">
            <ng-select [(ngModel)]="filter_status" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" (ngModelChange)="search()" [clearable]="false" (clear)="filter_status = -1">
              <ng-option [value]="-1">
                <span class="font-small-4 font-weight-normal">{{ "ALL_STATUS" | translate }}</span>
              </ng-option>
              <ng-option *ngFor="let status of statusRequestLabels; let i = index" [value]="i">
                <span class="font-small-4 font-weight-normal">{{ status }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 fix-ng-select-clear">
            <ng-select has_capability="bargaining_view_others" [closeOnSelect]="true" [(ngModel)]="filterCommercial" [clearable]="filterCommercial.length > 0" (clear)="filterCommercial = ''" (change)="search()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2">{{'CUSTOMER_COMMERCIAL' | translate}}: {{ item || ('ALL' | translate) }}</span>
              </ng-template>
              <ng-option [value]="''">
                <span class="font-small-4 font-weight-normal">{{'ALL' | translate}}</span>
              </ng-option>
              <ng-option *ngFor="let comm of commercialList" [value]="comm">
                <span class="font-small-4 font-weight-normal">{{comm}}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 col-12 text-right">
            <div class="mr-2" [ngClass.xl]="'d-inline-block'" [ngClass.sm]="'d-none'" [ngClass.md]="'d-none'">
              <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
            </div>
            <a routerLink="/dashboard/create-bargaining" class="btn btn-outline-primary" has_capability="create_bargaining">{{ "ADD" | translate }}</a>
          </div>
        </div>
      </div>
      <!--desktop-->
      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 80 : 200"
          [limit]="tableLimit"
          [footerHeight]="30"
          [rows]="filtered_list"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
        >
          <!-- request-->
          <ngx-datatable-column [name]="'REQUEST' | translate" prop="request_name" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a routerLink="/dashboard/detail-request/{{ row?.request?.id }}" target="_blank" class="text-break-line-2">{{ row.request_name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TITLES.USERS_TYPES_SINGULAR.candidate' | translate" prop="user.complete_name" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a
                [routerLink]="row.status < 1 || (row.status == 1 && _utilService.formatDate(row.start_date) < today) ? '/dashboard/candidate/edit/' + row.user.hash : '/dashboard/user/profile/' + row.user.hash"
                target="_blank"
                >{{ row.user.complete_name }}</a
              >
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CUSTOMER_COMMERCIAL' | translate" prop="commercial.complete_name" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a routerLink="/dashboard/user/profile/{{ row.commercial?.hash }}" target="_blank">{{ row.commercial?.complete_name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'STATE' | translate" prop="status" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge" [ngClass]="{ 'badge-light-secondary': row.status == 0, 'badge-light-success': row.status == 1, 'badge-light-danger': row.status == 2 }">{{ statusRequestLabels[row.status] }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'STATUS_DOCUMENTS' | translate" prop="status_document" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span
                class="badge"
                [ngClass]="{
                  'badge-light-secondary': row.status_document == 0,
                  'badge-light-info': row.status_document == 1,
                  'badge-light-warning': row.status_document == 2,
                  'badge-light-success': row.status_document == 3,
                  'badge-light-danger': row.status_document == 4
                }"
                >{{ statusSendLabels[row.status_document] }}</span
              >
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'STATUS_CONTRACT' | translate" prop="status_contract" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span
                class="badge"
                [ngClass]="{
                  'badge-light-secondary': row.status_contract == 0,
                  'badge-light-info': row.status_contract == 1,
                  'badge-light-warning': row.status_contract == 2,
                  'badge-light-success': row.status_contract == 3,
                  'badge-light-danger': row.status_contract == 4
                }"
                >{{ statusSendLabels[row.status_contract] }}</span
              >
            </ng-template>
          </ngx-datatable-column>
          <!-- action-->
          <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div ngbDropdown container="body">
                <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                  <span [data-feather]="'more-vertical'" class="cursor-pointer"></span>
                </button>
                <div ngbDropdownMenu>
                  <a *ngIf="row.status == 2" class="text-success" ngbDropdownItem (click)="restoreBargaining(row.id)"> <i [data-feather]="'plus'" size="16" class="mr-50"></i> {{ "ENABLE" | translate }} </a>
                  <a *ngIf="row.status_document === 0 || row.status_document === null" (click)="requestDocumentMasterData(row)" ngbDropdownItem>
                    <i [data-feather]="'send'" size="16" class="mr-50"></i> {{ "SEND_REQUEST_DOCUMENT" | translate }}
                  </a>
                  <a *ngIf="(row.status_contract === 0 || row.status_contract === null) && row.status_document === 3 && row.status !== 2" (click)="requestDocumentContract(row)" ngbDropdownItem>
                    <span [data-feather]="'file-text'" size="16" class="mr-50"></span> {{ "SEND_CONTRACT" | translate }}
                  </a>
                  <a ngbDropdownItem [routerLink]="'/dashboard/edit-bargaining/' + row.id"> <span [data-feather]="'eye'" size="16" class="mr-50"></span> {{ "VIEW" | translate }} </a>
                  <a ngbDropdownItem *ngIf="row.status == 0 && _authenticationService.hasCapability('edit_bargaining')" [routerLink]="'/dashboard/edit-bargaining/' + row.id">
                    <span [data-feather]="'edit'" size="16" class="mr-50"></span> {{ "EDIT" | translate }}
                  </a>
                  <a ngbDropdownItem class="text-danger" (click)="deleteBargaining(row.id)" *ngIf="_authenticationService.hasCapability('delete_bargaining')">
                    <span [data-feather]="'trash'" size="16" class="mr-50"></span> {{ "DELETE" | translate }}
                  </a>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'REQUEST' | translate" prop="request" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <!-- request-->
                <div class="col-10 p-0">
                  <div class="text-break-line-1">
                    <a routerLink="/dashboard/detail-request/{{ row?.request?.id }}" target="_blank">{{ row.request_name }}</a>
                  </div>
                  <div>
                    <!-- candidate-->
                    <span class="">{{ "TITLES.USERS_TYPES_SINGULAR.candidate" | translate }}: </span>
                    <a
                      [routerLink]="row.status < 1 || (row.status == 1 && _utilService.formatDate(row.start_date) < today) ? '/dashboard/candidate/edit/' + row.user.hash : '/dashboard/user/profile/' + row.user.hash"
                      target="_blank"
                      >{{ row.user.complete_name }}</a
                    >
                  </div>
                  <div>
                    <!-- commercial-->
                    <span class="">{{ "CUSTOMER_COMMERCIAL" | translate }}: </span>
                    <a routerLink="/dashboard/user/profile/{{ row.commercial?.hash }}" target="_blank">{{ row.commercial?.complete_name }}</a>
                  </div>
                  <!-- statusRequest-->
                  <div>
                    <span>{{ "STATUS_LABEL" | translate }}: </span>
                    <span class="badge" [ngClass]="{ 'badge-light-secondary': row.status == 0, 'badge-light-success': row.status == 1, 'badge-light-danger': row.status == 2 }">{{ statusRequestLabels[row.status] }}</span>
                  </div>
                  <!-- statusDocument-->
                  <div>
                    <span>{{ "STATUS_DOCUMENT" | translate }}: </span>
                    <span
                      class="badge"
                      [ngClass]="{
                        'badge-light-secondary': row.status_document == 0,
                        'badge-light-info': row.status_document == 1,
                        'badge-light-warning': row.status_document == 2,
                        'badge-light-success': row.status_document == 3,
                        'badge-light-danger': row.status_document == 4
                      }"
                      >{{ statusSendLabels[row.status_document] }}</span
                    >
                  </div>
                  <!-- statusContract-->
                  <div>
                    <span>{{ "STATUS_CONTRACT" | translate }}: </span>
                    <span
                      class="badge"
                      [ngClass]="{
                        'badge-light-secondary': row.status_contract == 0,
                        'badge-light-info': row.status_contract == 1,
                        'badge-light-warning': row.status_contract == 2,
                        'badge-light-success': row.status_contract == 3,
                        'badge-light-danger': row.status_contract == 4
                      }"
                      >{{ statusSendLabels[row.status_contract] }}</span
                    >
                  </div>
                </div>
                <div class="col-2">
                  <!-- action-->
                  <div ngbDropdown container="body">
                    <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow" rippleEffect>
                      <span [data-feather]="'more-vertical'" class="cursor-pointer"></span>
                    </button>
                    <div ngbDropdownMenu>
                      <a *ngIf="row.status == 2" class="text-success" ngbDropdownItem (click)="restoreBargaining(row.id)"> <i [data-feather]="'plus'" size="16" class="mr-50"></i> {{ "ENABLE" | translate }} </a>
                      <a *ngIf="row.status_document === 0 || row.status_document === null" (click)="requestDocumentMasterData(row)" ngbDropdownItem>
                        <i [data-feather]="'send'" size="16" class="mr-50"></i> {{ "SEND_REQUEST_DOCUMENT" | translate }}
                      </a>
                      <a *ngIf="(row.status_contract === 0 || row.status_contract === null) && row.status_document === 3 && row.status !== 2" (click)="requestDocumentContract(row)" ngbDropdownItem>
                        <span [data-feather]="'file-text'" size="16" class="mr-50"></span> {{ "SEND_CONTRACT" | translate }}
                      </a>
                      <a ngbDropdownItem [routerLink]="'/dashboard/edit-bargaining/' + row.id"> <span [data-feather]="'eye'" size="16" class="mr-50"></span> {{ "VIEW" | translate }} </a>
                      <a ngbDropdownItem [routerLink]="'/dashboard/edit-bargaining/' + row.id"> <span [data-feather]="'edit'" size="16" class="mr-50"></span> {{ "EDIT" | translate }} </a>
                      <a ngbDropdownItem class="text-danger" (click)="deleteBargaining(row.id)"> <span [data-feather]="'trash'" size="16" class="mr-50"></span> {{ "DELETE" | translate }} </a>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
